<template>
  <div class="container-fluid">

    <div class="row py-3">
      <div class="col-md-12">
        <h1 class="text-center">Users</h1>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-md-12 d-flex">
        <b-button variant="success" to="/users/create">Create user</b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <users-table :users="users"></users-table>

        <b-pagination v-if="total > itemsPerPage" size="md" :total-rows="total" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>

        <loading :loading="loading"></loading>

      </div>
    </div>

  </div>
</template>


<script>
import UsersTable from '../components/tables/UsersTable'

export default {
  components: {
    UsersTable,
  },
  created() {
    const users = this.$store.getters.getUsers(this.currentPage)

    if (!users.length) {
      this.loadUsers(this.currentPage)
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      itemsPerPage: 20,
    }
  },
  computed: {
    users() {
      return this.$store.getters.getUsers(this.currentPage)
    },
    total() {
      return this.$store.getters.getUsersTotal
    },
  },
  methods: {
    loadUsers(page) {
      this.loading = true
      this.$store.dispatch('getUsers', {page, itemsPerPage: this.itemsPerPage})
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    currentPage() {
      this.loadUsers(this.currentPage)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/UsersPage.vue